const _excluded = ["audio", "lazy", "components"],
  _excluded2 = ["CameraContainer", "CameraLoad", "CameraError"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useLazyCamera } from "../../hooks";
import { MediaTrackType } from "../../view-model";
import { components as defaultComponents } from "./components";
import { CameraStream } from "./camera-stream.component";
import '@isyc-react/design/main';
import "./camera.style.scss";

// TODO Resolution or force resolution etc ideal, min ...
// TODO if audio input add microphone UX when ready
export const Camera = props => {
  const {
      audio = false,
      lazy = false,
      components = defaultComponents
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
      CameraContainer = defaultComponents.CameraContainer,
      CameraLoad = defaultComponents.CameraLoad,
      CameraError = defaultComponents.CameraError
    } = components,
    restComponents = _objectWithoutProperties(components, _excluded2);
  const [facingMode, setFacingMode] = React.useState(null);
  const [videoInputId, setVideoInputId] = React.useState(null);
  const [audioInputId, setAudioInputId] = React.useState(null);
  const constraints = React.useMemo(() => ({
    audio: audio ? {
      deviceId: audioInputId ? {
        exact: audioInputId
      } : undefined
    } : false,
    video: {
      facingMode: facingMode ? {
        exact: facingMode
      } : undefined,
      deviceId: videoInputId ? {
        exact: videoInputId
      } : undefined,
      width: {
        ideal: 4096
      },
      height: {
        ideal: 2160
      },
      aspectRatio: 1.7777778
    }
  }), [audio, facingMode, videoInputId, audioInputId]);
  const [open,, state] = useLazyCamera(constraints);
  const {
    loading,
    error,
    stream
  } = state;
  // TODO pass ref atribute and bind open and close to its camera instance
  // (customize ref instance with React useImperativeHandle hook)

  React.useEffect(() => {
    if (!lazy) open();
  }, [lazy, open]);

  // if (error) console.error('ERROR CAMERA GET USER MEDIA: ', error, error.name, error.message)
  // console.log('SRC CAMERA GET USER MEDIA: ', stream)
  // console.log('CURRENT STREAM DATA: ', data)
  // TODO put audio analyser and make microphone real time feedback

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CameraContainer, null, loading ? /*#__PURE__*/React.createElement(CameraLoad, {
    audio: audio
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, error ? /*#__PURE__*/React.createElement(CameraError, {
    error: error,
    retry: open,
    audio: audio
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, stream && /*#__PURE__*/React.createElement(CameraStream, _extends({}, rest, {
    audio: audio,
    state: state,
    device: {
      audioInputId,
      videoInputId
    },
    facingMode: facingMode,
    onFacingModeChange: setFacingMode,
    onDeviceChange: change => {
      switch (change.type) {
        case MediaTrackType.AUDIO_INPUT:
          setAudioInputId(change.device.deviceId);
          break;
        case MediaTrackType.VIDEO_INPUT:
          setVideoInputId(change.device.deviceId);
          break;
        default:
          break;
      }
    },
    components: restComponents
  }))))));
};